module.exports = __webpack_public_path__ + "img/icon-link.a4c51b8a.svg";